var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6797_16318",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6797_16318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58366 28C4.85033 28 4.22255 27.7389 3.70033 27.2167C3.1781 26.6944 2.91699 26.0667 2.91699 25.3333V6.66667C2.91699 5.93333 3.1781 5.30556 3.70033 4.78333C4.22255 4.26111 4.85033 4 5.58366 4H13.5837C14.317 4 14.9448 4.26111 15.467 4.78333C15.9892 5.30556 16.2503 5.93333 16.2503 6.66667V9.33333H26.917C27.6503 9.33333 28.2781 9.59444 28.8003 10.1167C29.3225 10.6389 29.5837 11.2667 29.5837 12V25.3333C29.5837 26.0667 29.3225 26.6944 28.8003 27.2167C28.2781 27.7389 27.6503 28 26.917 28H5.58366ZM5.58366 25.3333H13.5837V22.6667H5.58366V25.3333ZM5.58366 20H13.5837V17.3333H5.58366V20ZM5.58366 14.6667H13.5837V12H5.58366V14.6667ZM5.58366 9.33333H13.5837V6.66667H5.58366V9.33333ZM16.2503 25.3333H26.917V12H16.2503V25.3333ZM20.2503 17.3333C19.8725 17.3333 19.5559 17.2056 19.3003 16.95C19.0448 16.6944 18.917 16.3778 18.917 16C18.917 15.6222 19.0448 15.3056 19.3003 15.05C19.5559 14.7944 19.8725 14.6667 20.2503 14.6667H22.917C23.2948 14.6667 23.6114 14.7944 23.867 15.05C24.1225 15.3056 24.2503 15.6222 24.2503 16C24.2503 16.3778 24.1225 16.6944 23.867 16.95C23.6114 17.2056 23.2948 17.3333 22.917 17.3333H20.2503ZM20.2503 22.6667C19.8725 22.6667 19.5559 22.5389 19.3003 22.2833C19.0448 22.0278 18.917 21.7111 18.917 21.3333C18.917 20.9556 19.0448 20.6389 19.3003 20.3833C19.5559 20.1278 19.8725 20 20.2503 20H22.917C23.2948 20 23.6114 20.1278 23.867 20.3833C24.1225 20.6389 24.2503 20.9556 24.2503 21.3333C24.2503 21.7111 24.1225 22.0278 23.867 22.2833C23.6114 22.5389 23.2948 22.6667 22.917 22.6667H20.2503Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedio);
export default __webpack_public_path__ + "static/media/medio.fcb3f0df668e53c58ae91a7cbaa80b96.svg";
export { ForwardRef as ReactComponent };